import { Menu } from "react-native-popup-menu";
export default Menu;
